/**
 * Created by yangHuan on 17/9/20.
 */

export const queryStringArgs = (() => {
    const search = decodeURIComponent(location.search);
    const qs = search ? search.substring(1) : '';
    const items = qs ? qs.split('&') : [];
    const args = {};
    items.forEach((item) => {
        const [name, value] = item.split('=');
        if (name) {
            args[name] = value;
        }
    });
    return args;
})();

export const getCookieArgs = (() => {
    const cookie = unescape(document.cookie);
    const items = cookie ? cookie.split(';') : [];
    const args = {};
    items.forEach((item) => {
        const [name, value] = item.trim().split('=');
        if (name) {
            args[name] = value;
        }
    });
    return args;
})();

export const isArray = (arr) => Object.prototype.toString.call(arr) === '[object Array]';

export const isObject = (obj) => Object.prototype.toString.call(obj) === '[object Object]';

export const getArray = (arr) => isArray(arr) ? arr : [];

export const getObject = (obj) => isObject(obj) ? obj : {};


// WEBPACK FOOTER //
// ./src/lib/util.js